<template>
  <section>
    <div class="header">
      <div class="logo">
        <img :src="getOptionData('companyLargeIcon', companyID).logo">
      </div>
      <div class="name">{{getOptionData('companyLargeIcon', companyID).name}}</div>
    </div>
    <div class="main">
      <div class="product-list">
        <ul>
          <li>Plans</li>
          <li
            v-for="(item, i) in list"
            :key="i"
            :class="{'active': i == list_active}"
            class="pointer"
            @click="productClick(i)">
            {{item.name}}
          </li>
        </ul>
      </div>
      <div
        v-if="list.length > 0"
        class="plan-list">
        <ul>
          <li>Name</li>
          <template v-if="list[list_active].plan_list">
            <li
              v-for="(val, key, i) in list[list_active].plan_list"
              :key="i" 
              class="pointer"
              @click="planClick(key)">
              {{val}}
            </li>
          </template>
          <template v-else>
            <li class="empty">No Data</li>
          </template>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getInsurerPlanList} from '@/api/account'
import {mapState, mapActions} from 'vuex'

export default {
  name: 'InsurerPlan',
  mixins: [MixinOptions],
  data () {
    return {
      list:[],
      list_active: 0,
    }
  },
  computed:{
    ...mapState('account', ['insurerListActive', 'insurerCompanyId']),
    companyID(){
      return this.$route.query.company_id
    }
  },
  watch:{
    companyID:{
      immediate: true,
      handler(v){
        if(v){
          this.network().getInsurerPlanList()
        }
      }
    },
    insurerListActive:{
      immediate: true,
      handler(v){
        if(v != null){
          if(this.insurerCompanyId == this.companyID){
            this.list_active = v
          }
        }
      }
    }
  },
  methods: {
    ...mapActions('account', ['setinsurerListActive', 'setInsurerCompanyId','setInsurerPlanList']),
    productClick(index){
      this.list_active = index
      this.setinsurerListActive(index)
      this.setInsurerCompanyId(this.companyID)
    },
    planClick(id){
      this.$router.push({
        name: 'insurerAccountsPlanDetail',
        query:{
          company_id: this.companyID,
          class_id: this.list[this.list_active].id,
          plan_id: id
        }
      })
    },
    network(){
      return{
        getInsurerPlanList: async () => {
          const {data} = await getInsurerPlanList({
            company_id: this.companyID
          })
          this.setInsurerPlanList(data)
          this.list = data
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.header{
  height: 50px;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  .logo{
    height: 50px;
    margin-right: 15px;
    img{
      height: 100%;
    }
  }
  .name{
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    height: 24px;
    color: #24292E;
  }
}
.main{
  display: flex;
  ul{
    list-style-type: none;
    border-radius: 6px;
    li{
      font-size: 14px;
      border: 1px solid #E1E4E8;
      & + li{
        border-top: 0;
      }
      &:first-child{
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        color: #1B1F23;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
      }
      &:last-child{
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
      }
    }
  }
  .product-list{
    margin-right: 30px;
    ul{
      width: 280px;
      li{
        background: #FAFBFC;
        padding: 12px 16px;
        height: 45px;
        color: #24292E;
        font-weight: 400;
        &:first-child{
          height: 38px;
          background: #FFFFFF;
          padding: 9px 16px;
          font-weight: 600;
        }
        &.active{
          background: #FFFFFF;
          border-left: 3px solid #f9816c;
        }
      }
    }
  }
  .plan-list{
    flex: 1;
    margin-right: 70px;
    ul{
      li{
        height: 40px;
        padding: 10px 15px;
        color: #24292E;
        font-weight: 600;
        &:first-child{
          background: #FAFBFC;
        }
        &.empty{
          text-align: center;
          color: #909399;
          font-size: 14px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
